import { Flex, Text } from '@cad-arc';
import React from 'react';

export const UnverifiedAddressIndicator: React.FC = () => {
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            w="100%"
            h="100%"
            background="surface.foreground"
        >
            <Flex
                alignItems="center"
                borderRadius={3}
                border="sm"
                borderColor="border.default"
                w="60%"
                textAlign="center"
                justifyContent="center"
                h="25%"
                textTransform="initial"
                paddingX={4}
            >
                <Text noOfLines={2} variant="headingXs">
                    Map can only display verified addresses.
                </Text>
            </Flex>
        </Flex>
    );
};
